import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from "@angular/http";
import 'rxjs/add/operator/toPromise';

import { Fmt } from '../../fmt.service';

@Injectable()
export class WhitelistService {
    constructor(
        public _fmt: Fmt,
    ) {}

    LoadWhitelists<T>(): Observable<T> {
        let params = new URLSearchParams();

        return this._fmt.HttpGet<T>('/api/get_whitelist', params)
    }

    SaveWhitelist(whitelist: any[]) {
        return this._fmt.HttpPost('/api/save_whitelist', whitelist)
    }

    ClearSupervisorCache(){
        return this._fmt.HttpPost('/api/v1/clear_sv_cache', {}); 
    }
}

export interface Whitelist {
    ID: number,
    Email: string,
    CreatedAt: Date
}